import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { compose } from 'ramda';
import {
  reduxForm,
  FieldArray,
  Form,
  InjectedFormProps,
  Field,
  isValid
} from 'redux-form';
import { Button } from 'components/Base';
import Store from 'store/store';
import { PolicyType } from 'store/modules/Policies/types';
import Forms from 'components/Forms';
import Fields from 'components/Fields';
import { Validators } from 'components/Forms/Validators';
import { FundType } from 'store/modules/Funds/types';
import BottomNavBar from 'components/Cases/BottomNavBar';

const { connect, selectors } = Store;

const useStyles = makeStyles({
  form: {
    width: '100%',
    paddingBottom: '36px'
  }
});

interface PortfolioBuilderProps {
  policy: PolicyType;
  policyType: string;
  policyProvider: string;
  isValid: boolean;
  cipFunds: Array<FundType>;
  cipTemplate: Array<FundType>;
}

const PortfolioBuilder = ({
  policy,
  handleSubmit,
  submitting,
  isValid,
  cipFunds,
  cipTemplate
}: PortfolioBuilderProps & InjectedFormProps) => {
  const classes = useStyles();
  const { wrap_retained, wrap_percentage, performed_action } = policy;
  const isRetaintActionApplied = policy.performed_action === 1;

  return (
    <Form onSubmit={handleSubmit} className={classes.form}>
      <Grid item xs={12}>
        <FieldArray
          name="fund_allocations"
          component={Forms.PortfolioBuilder.Funds}
          rerenderOnEveryChange
          isWrap={!!wrap_percentage}
          wrapRetained={wrap_retained}
          cipFunds={cipFunds}
          cipTemplate={cipTemplate}
          performedAction={performed_action}
        />

        <Field name="fund_error" component={Fields.Warn} />

        <BottomNavBar
          rightButtons={[
            <Button
              key={
                isRetaintActionApplied ? 'Close Button' : 'Save & Close Button'
              }
              isLoading={submitting}
              disabled={!isValid}
              color="primary"
              type="submit"
            >
              {isRetaintActionApplied ? 'Close' : 'Save & Close'}
            </Button>
          ]}
        />
      </Grid>
    </Form>
  );
};

export default compose(
  reduxForm({
    form: 'portfolioBuilder',
    validate: Validators.portfolioBuilder
  }),
  connect((state: any) => ({
    policy: selectors.portfolioBuilderSelectors.policy(state),
    cipFunds: selectors.portfolioBuilderSelectors.cipFunds(state),
    isValid: isValid('portfolioBuilder')(state),
    cipTemplate: selectors.portfolioBuilderSelectors.cipTemplate(state)
  }))
)(PortfolioBuilder);
